import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "actions"];
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { TABS } from 'collaboration-sidebar/constants/tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TabHeader = _ref => {
  let {
      children,
      actions
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    alignItems: "center",
    paddingBlock: "400",
    paddingInlineStart: "800",
    paddingInlineEnd: "500",
    flexGrow: 0,
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    borderBlockEndColor: "border-core-subtle"
    /* ensure actions don't create inconsistent height */,
    minBlockSize: "64px"
  }, props, {
    children: [/*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        children: children
      })
    }), actions]
  }));
};
export default function Tab({
  heading,
  actions,
  children,
  showHeader = true,
  tab
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    flexDirection: "column",
    alignItems: "stretch",
    children: [showHeader && /*#__PURE__*/_jsx(TabHeader, {
      backgroundColor: tab === TABS.COMMENTS ? 'fill-surface-default' : undefined,
      actions: actions,
      children: heading
    }), /*#__PURE__*/_jsx(Box, {
      grow: 1,
      minBlockSize: "0%",
      overflowY: "auto",
      position: "relative",
      children: children
    })]
  });
}